import { Tooltip } from 'antd';
import { cloneElement, FunctionComponent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// hooks
import useCompanySuspended from 'core/hooks/useCompanySuspended';

interface SuspendedTooltipProps {
	children: ReactElement<{ disabled?: boolean }>;
}

/**
 * Wraps any action that creates or updates a record. While the company is generally suspended the
 * wrapped element is disabled and a tooltip explains why, otherwise it is rendered untouched.
 */
const SuspendedTooltip: FunctionComponent<SuspendedTooltipProps> = ({ children }) => {
	const { t } = useTranslation();

	const { isGeneralSuspended } = useCompanySuspended();

	if (!isGeneralSuspended) return children;

	return (
		<Tooltip color="red" title={t('COMMON.COMPANY_GENERAL_SUSPENDED')}>
			{cloneElement(children, { disabled: true })}
		</Tooltip>
	);
};

export default SuspendedTooltip;
